<template>
  <main class="container">
    <section class="content">
      <div class="notice">
        <div class="notice_header">
          죄송합니다 <br />
          페이지를 찾을 수 없습니다
        </div>
        <div class="notice_description">
          존재하지 않는 주소를 입력하셨거나 <br />요청하신 페이지의 주소가
          <br class="only-mobile" />변경, 삭제되어 찾을 수 없습니다.
        </div>
        <button class="home" @click="$router.push('/')">홈으로</button>
      </div>
      <div class="img_404"><img src="@/assets/img/404.png" /></div>
    </section>
  </main>
</template>

<script>
export default {
  metaInfo: {
    title: "페이지를 찾을 수 없습니다"
  }
};
</script>
<style src="./index.css" scoped />
